export default "__VITE_ASSET__DBXUune$__"